function getClientRollbarConfigs() {
  const modernBrowsersRegexp = require('./browserlistModernRegexp');
  const { ENVIRONMENT, ROLLBAR_CLIENT_ACCESS_TOKEN, APP_BUILD_ID } = require('./constants');
  const hostSafeList = ['concern.net', 'concern.org.uk', 'systemseed.host', 'concern.local'];

  return {
    enabled: !!ROLLBAR_CLIENT_ACCESS_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
    environment: ENVIRONMENT ?? 'undefined',
    accessToken: ROLLBAR_CLIENT_ACCESS_TOKEN,
    scrubTelemetryInputs: true,
    checkIgnore: (isUncaught, args, payload) => {
      // Ignore "Script error." exception for now, it throws an error in "HeadlessChrome" browser.
      // Every automated test thrown that error for some reason. Does not reproducible for usual browsers.
      // This condition was added during implementation of CWIESP-2964 story.
      // Todo: improve it.
      if (isUncaught && args[0] && args[0] === 'Script error.') {
        return true;
      }

      // Ignore errors if we can't figure out user browser.
      if (!navigator || !navigator.userAgent) {
        return true;
      }
      // Ignore errors if they come from old browsers.
      if (!modernBrowsersRegexp.test(navigator.userAgent)) {
        return true;
      }
      // Ensuring error is sent from the allowed list of domains. Ignore
      // errors sent from other domains. See #186330176 for details.
      const url = payload.request.url ?? '';
      return !url || hostSafeList.every((host) => !url.includes(host));
    },
    payload: {
      environment: ENVIRONMENT,
      client: {
        javascript: {
          source_map_enabled: true,
          code_version: APP_BUILD_ID,
          guess_uncaught_frames: true,
        },
      },
    },
  };
}

function getRollbar() {
  if (typeof window === 'undefined') {
    const Rollbar = require('rollbar');
    return new Rollbar({
      enabled: !!process.env.ROLLBAR_SERVER_ACCESS_TOKEN,
      captureUncaught: true,
      captureUnhandledRejections: true,
      environment: process.env.ENVIRONMENT ?? 'undefined',
      accessToken: process.env.ROLLBAR_SERVER_ACCESS_TOKEN ?? undefined,
    });
  } else {
    const clientConfig = getClientRollbarConfigs();
    const Rollbar = require('rollbar');
    return new Rollbar(clientConfig);
  }
}

module.exports = getRollbar();
